import React from 'react';
import { Card, Typography, List, Button, Divider, Space } from 'antd';
import { RocketOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const MenteeWelcome = ({ onGetStarted }) => {
    const encouragementPoints = [
        "Be open, curious, and reflective",
        "Take ownership of your growth and goals",
        "Engage actively and respectfully with your mentor",
        "Apply insights gained to your personal and professional life"
    ];

    return (
        <div style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px' }}>
            <Card 
                bordered={false} 
                // style={{ borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', textAlign: 'center' }}
            >
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <div style={{ background: '#fff1f0', width: '80px', height: '80px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto' }}>
                        <RocketOutlined style={{ fontSize: '40px', color: '#FE1F08' }} />
                    </div>

                    <Title level={2}>Welcome to ElevateHer!</Title>
                    
                    <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
                        Congratulations on taking an intentional step toward your personal and professional growth. 
                        By joining this programme, you have chosen to invest in your confidence, clarity, and future.
                    </Paragraph>

                    <Divider>Your Journey as a Mentee</Divider>

                    <List
                        dataSource={encouragementPoints}
                        renderItem={(item, index) => (
                            <List.Item style={{ border: 'none', textAlign: 'left', padding: '8px 0' }}>
                                <Space align="start">
                                    <CheckCircleOutlined style={{ color: '#52c41a', marginTop: '5px' }} />
                                    <Text>{item}</Text>
                                </Space>
                            </List.Item>
                        )}
                    />

                    <Card style={{ background: '#f9f9f9', borderRadius: '12px', border: 'none', marginTop: '20px' }}>
                        <Paragraph italic style={{ marginBottom: 0 }}>
                            "ElevateHer is a safe, supportive space designed to help you grow with confidence and purpose. 
                            We believe in your potential."
                        </Paragraph>
                        <Text strong style={{ display: 'block', marginTop: '10px' }}>
                            — Rita Adu Boateng, Founder and CEO
                        </Text>
                    </Card>

                    <Button 
                        type="primary" 
                        size="large" 
                        block 
                        style={{ height: '50px', borderRadius: '8px', background: '#FE1F08', borderColor: '#FE1F08', marginTop: '20px' }}
                        onClick={onGetStarted}
                    >
                        Let's Begin My Journey
                    </Button>
                </Space>
            </Card>
        </div>
    );
};

export default MenteeWelcome;